module.exports = __webpack_public_path__ + "static/media/acciona.5ba36b97.png";